import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const initialState = {
  fromDate: dayjs().startOf('month').toISOString(),
  toDate: dayjs().endOf('month').toISOString(),
  filterModel: null,
  sortModel: null,
  page: 0,
  persisted: false,
  ordersCache: {},
};

const salesOrdersSlice = createSlice({
  name: 'salesOrders',
  initialState,
  reducers: {
    setDateRange(state, action) {
      const { fromDate, toDate } = action.payload;
      state.fromDate = fromDate;
      state.toDate = toDate;
      state.persisted = true;
    },
    saveGridState(state, action) {
      const { filterModel, sortModel, page } = action.payload;
      state.filterModel = filterModel || null;
      state.sortModel = sortModel || null;
      state.page = typeof page === 'number' ? page : 0;
      state.persisted = true;
    },
    saveOrdersToCache(state, action) {
      const { key, data } = action.payload;
      state.ordersCache[key] = data;
    },
    clearSalesOrdersState() {
      return initialState;
    },
  },
});

export const { setDateRange, saveGridState, clearSalesOrdersState, saveOrdersToCache } =
  salesOrdersSlice.actions;

export default salesOrdersSlice.reducer;



